import { Fragment } from "react";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ navs, title }) => {
  // Bread Crumb Document

  // BreadCrumb Name : name
  // BreadCrumb URL : url
  // BreadCrumb Type : type { l : Link , a: Active , d : Default}

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <h4 className="page-title mb-0 font-size-18">{title}</h4>

          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {navs.map((nav) => (
                <Fragment>
                  {nav.type === "l" ? (
                    <li className="breadcrumb-item">
                      <Link to={nav.url}>{nav.name}</Link>
                    </li>
                  ) : nav.type === "a" ? (
                    <li className="breadcrumb-item active">{nav.name}</li>
                  ) : (
                    <li className="breadcrumb-item">
                      <a href>{nav.name}</a>
                    </li>
                  )}
                </Fragment>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
